import React, { createContext, useContext, useMemo, useReducer } from 'react';
import {
  createInitialWorkspaceState,
  workspaceReducer,
  WORKSPACE_ACTIONS,
} from './workspaceReducer';

const WorkspaceContext = createContext(null);

export function WorkspaceProvider({ children }) {
  const [state, dispatch] = useReducer(workspaceReducer, undefined, createInitialWorkspaceState);

  const value = useMemo(() => ({ state, dispatch, actions: WORKSPACE_ACTIONS }), [state]);

  return (
    <WorkspaceContext.Provider value={value}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspace() {
  const ctx = useContext(WorkspaceContext);
  if (!ctx) {
    throw new Error('useWorkspace must be used within WorkspaceProvider');
  }
  return ctx;
}

/** @deprecated WorkspaceProvider is always mounted; use useWorkspace() instead. */
export function useWorkspaceOptional() {
  return useContext(WorkspaceContext);
}